<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm2 md3>
        <v-layout wrap justify-center>
          <template v-for="(photos, j) in storage.product">
            <v-flex
              :xs6="storage.product.length > 1 ? true : false"
              :key="j"
              v-if="j < 2"
              pa-1
              text-center
              align-self-center
            >
              <v-img
                :src="baseURL + '/u/' + photos.photos[0]"
                height="100px"
                contain
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="#FF2323"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-flex>
          </template>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm10 md9>
        <v-layout wrap justify-center fill-height>
          <v-flex xs12 sm9 md9 lg9 xl10 text-left>
            <v-layout wrap justify-start style="line-height: 16px" fill-height>
              <v-flex xs12 align-self-start>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 12px;
                    color: #42af54;
                  "
                >
                  Order No : {{ storage.orderno }}
                </span>
              </v-flex>
              <v-flex xs12 align-self-start>
                <router-link :to="'/Seller/Orders/' + storage.transaction_id">
                  <span
                    style="
                      font-family: poppinsmedium;
                      font-size: 16px;
                      color: #000000;
                    "
                  >
                    {{ storage.productname.slice(0, 25) }}
                    <span v-if="storage.productname.length > 25">...</span>
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 12px;
                    color: #000000;
                  "
                >
                  <!-- {{ storage.firstname }} {{ storage.lastname }} -->
                  {{ storage.product.length }} Item<span
                    v-if="storage.product.length > 1"
                    >'s</span
                  >
                </span>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                >
                  Rs. {{ storage.amount }}
                </span>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 12px;
                    color: #6c6c6c;
                  "
                >
                  Transaction Id : {{ storage.transaction_id }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage"],
  data() {
    return {};
  },
};
</script>